import React, { useEffect, useRef, useState } from 'react'
import "./PopOver.css"
function TimePicker({ defaultValue, format = "HH:mm", onValueChange, }) {
    console.log(defaultValue)
    const [isOpen, setIsOpen] = useState(false)
    const hours = Array.from({ length: 24 }, (_, i) => i > 9 ? i : '0' + i);
    const minutes = Array.from({ length: 60 }, (_, i) => i > 9 ? i : '0' + i);

    const [value, setValue] = useState(defaultValue || "00:00")

    const popoverRef = useRef(null)

    useEffect(() => {
        if (!defaultValue) {
            const date = new Date()
            const currenthour = date.getHours()
            const currentMinutes = date.getMinutes()
            setValue(`${currenthour > 9 ? currenthour : '0' + currenthour}:${currentMinutes > 9 ? currentMinutes : '0' + currentMinutes}`)
        }
    }, [])

    useEffect(() => {
        if (isOpen)
            scroll()
    }, [isOpen,value])

    const handleUpdate = (type, inputvalue) => {
        if (type === 'hours') {
            const preminutes = value.split(':')[1]
            setValue(`${inputvalue}:${preminutes}`)
            if (typeof onValueChange === 'function') {
                onValueChange(new Date().setHours(parseInt(inputvalue), parseInt(preminutes)))
            }
        } else if (type === "minutes") {
            const preHours = value.split(':')[0]
            setValue(`${preHours}:${inputvalue}`)
            setIsOpen(false)
            if (typeof onValueChange === 'function') {
                onValueChange(new Date().setHours(parseInt(preHours), parseInt(inputvalue)))
            }
        }else{
            const [preHours,preminutes]=inputvalue.split(':')
            setValue(inputvalue)
            if (typeof onValueChange === 'function') {
                onValueChange(new Date().setHours(parseInt(preHours), parseInt(preminutes)))
            }
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const scroll = () => {
        const preminutes = value.split(':')[1]
        const preHours = value.split(':')[0]
        const preHoursSection = document.getElementById(`${preHours + 'hoursId'}`);
        preHoursSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const preminutesSection = document.getElementById(`${preminutes + 'minutesId'}`);
        preminutesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };




    return (
        <div className="popover-container">
            <input
                onClick={() => setIsOpen(true)}
                type="time"
                format={format}
                value={value}
                onChange={(event)=>{handleUpdate(null, event.target.value)}}
                className="popover-button timePickerInput"
            />

            {isOpen && (
                <div className="popover" ref={popoverRef}>
                    <div className="popover-arrow"></div>
                    <div className="popover-content" style={{ height: 150 }}  >
                        <div style={{ display: 'flex', justifyContent: 'space-around', height: '100%' }} >
                            <div style={{ textAlign: 'center', width: '50%' }}>
                                <div style={{ padding: '4px', marginBottom: 4, position: 'sticky', top: 0, zIndex: 1, border: "1px solid black" }}>
                                    Hours
                                </div>
                                <div className='datePickerscroller' style={{ overflowY: 'auto', maxHeight: '110px' }}>
                                    {hours.map((ele, index) =>
                                        <div id={`${ele}hoursId`} onClick={() => handleUpdate('hours', ele)} className={`${value.split(':')[0] === String(ele) ? 'selectedDatePickerColor' : ''} hoverDatePickerEffect`} key={index + "hours"} style={{ padding: '2px 4px', cursor: 'pointer', transition: 'background 0.2s', backgroundColor: value.split(':')[0] === String(ele) ? "#006699" : "white" }}>
                                            {ele}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', width: '50%' }}>
                                <div style={{ padding: '4px', marginBottom: 4, borderLeft: "none", position: 'sticky', top: 0, zIndex: 1, border: "1px solid black" }}>
                                    Mins
                                </div>
                                <div className='datePickerscroller' style={{ overflowY: 'auto', maxHeight: '110px' }}>
                                    {minutes.map((ele, index) =>
                                        <div id={`${ele}minutesId`} className={`${value.split(':')[1] === String(ele) ? 'selectedDatePickerColor' : ''} hoverDatePickerEffect`} onClick={() => handleUpdate('minutes', ele)} key={index + "hours"} style={{ padding: '2px 4px', cursor: 'pointer', transition: 'background 0.2s', backgroundColor: value.split(':')[1] === String(ele) ? "#006699" : "white" }}>
                                            {ele}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default TimePicker